import React from "react";
import { useColors } from "../../constants/Colors";
import { useTranslation } from "react-i18next";

const FlatChatCard: React.FC = () => {
  const colors = useColors();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center py-8 gap-4">
      <div
        className="w-[80%] max-w-md rounded-3xl p-6"
        style={{ backgroundColor: colors.containerNeutralLightLowest }}
      >
        <p
          className="text-lg font-semibold"
          style={{ color: colors.textNeutralMuted }}
        >
          {t("flat_chat.title1") || "Welcome to your"}
        </p>
        <p
          className="text-4xl font-bold leading-tight"
          style={{ color: colors.textNeutralDefault }}
        >
          {t("flat_chat.title2") || "Flat Chat"}
        </p>
        <p className="mt-4" style={{ color: colors.textNeutralDefault }}>
          {t("flat_chat.subtitle") ||
            "You can use this chat to chat with your flatmates about your applications."}
        </p>
      </div>
    </div>
  );
};

export default FlatChatCard;
